import { Box, Flex, Text, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { colors } from 'theme/colors/colors';
import { AiOutlineInfoCircle } from 'react-icons/ai';

export interface DetailsBarProps {
  score: number;
  pillar: string;
  delta?: number;
}

const pillarLabelMap = {
  professionalBrand: {
    title: 'Your Professional Brand',
    info: 'Optimize your LinkedIn profile to resonate with your audience. Use Taplio’s AI to draft and schedule 2-3 value-packed posts this week that showcase your expertise',
  },
  findRightPeople: {
    title: 'Find the Right People',
    info: 'Leverage Taplio’s engagement tools to identify ideal prospects in your niche. Send 3 personalized connection requests each week to expand your network',
  },
  insightEngagement: {
    title: 'Engage with Insights',
    info: 'Share updates based on trending topics discovered with Taplio’s content inspiration tool. Post one insightful comment or reaction to a relevant industry topic daily.',
  },
  strongRelationship: {
    title: 'Build Strong Relationships',
    info: 'Taplio’s relationship management tools help you engage consistently. Leave meaningful comments on 3 decision-makers’ posts each day to deepen connections.',
  },
};

export const SsiDetailBar = ({ score, pillar, delta }: DetailsBarProps) => {
  const textLight = useColorModeValue(
    'text.lightMode.inactive',
    'text.darkMode.inactive'
  );

  let color;
  if (score > 0 && score <= 10) {
    color = colors.taplioDashboard.red;
  } else if (score > 10 && score <= 15) {
    color = colors.taplioDashboard.orange;
  } else if (score > 15 && score <= 21) {
    color = colors.taplioDashboard.yellow;
  } else if (score > 21) {
    color = colors.taplioDashboard.green;
  }

  return (
    <Box>
      <Flex pb={2} alignItems='center' justifyContent='space-between'>
        <Flex direction={'row'} alignItems='center'>
          <Text fontSize='sm' pr={2} fontWeight='500'>
            {pillarLabelMap[pillar].title}
          </Text>
          <Tooltip
            label={pillarLabelMap[pillar].info}
            fontSize='sm'
            hasArrow
            placement='right'
          >
            <span>
              <AiOutlineInfoCircle />
            </span>
          </Tooltip>
        </Flex>
        {delta ? (
          <Text fontSize='xs' fontWeight='500' color={textLight}>
            + {Math.round(delta)} Points
          </Text>
        ) : null}
      </Flex>
      <Box w='100%' h='3' backgroundColor='#F6F6F6' borderRadius='full'>
        <Box
          w={`${Math.ceil(Math.min((score / 25) * 100, 100))}%`}
          h='3'
          backgroundColor={color}
          borderRadius='full'
        ></Box>
      </Box>
    </Box>
  );
};
